@if (activeFacility$ | async; as activeFacility) {
  <button
    mat-button
    [elderOverlayOrigin]="contextPanel"
    [elderOverlayTrigger]="contextPanel"
    [disabled]="disabled"
  >
    <span class="layout-row place-center-center gap-sm">
      <mat-icon>business</mat-icon>
      <span>{{ activeFacility?.id }}</span>
    </span>
  </button>
}

<!-- Overlay Panel -->
<elder-overlay #contextPanel="elderOverlay">
  <elder-card-panel>
    <mat-form-field>
      <mat-label>{{ 'facilities.facility' | translate }}</mat-label>
      <elder-select
        appFacilitySelect
        [autoSelectFirst]="true"
        [value]="activeFacility$ | async"
        (valueUpdated)="activeFacility = $event"
      >
      </elder-select>
    </mat-form-field>
  </elder-card-panel>
</elder-overlay>
